import {Navigate, Outlet} from "react-router-dom";
import {useEffect} from "react";
// import {clearAuthStorage} from "../network/Interceptor/ResponseInterceptor";
import {useNavigate} from "react-router";
import { StorageConstants } from "../storage/storageConstants";
import { clearAuthStorage } from "../storage/AuthStorage";
import { useDispatch } from "react-redux";
import { setMobileNo, setUserId, setUsername } from "../actions/auth";

/**
 * @author Sarthak Sharma.
 * @since 08-12-2023.
 * @description Authenticated URL Mapping.
 * @returns React.ReactElement
 */

const ProtectRoute = (): React.ReactElement => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const loginTime = localStorage.getItem(StorageConstants.LOGIN_TIME);
        console.log(loginTime)
        if (loginTime){
            const loginDateTime = milisecondsToDate(+loginTime)
            checkLoginExpiration(loginDateTime)
            handleLocalData();
        } else{
            logoutAction()
        }
    }, [])

    const handleLocalData = async () => {
        const username = await localStorage.getItem(StorageConstants.USER_NAME);
        const userId = await localStorage.getItem(StorageConstants.USED_ID);
        const mobileNo = await localStorage.getItem(StorageConstants.MOBILE_NUMBER);

        await dispatch(setMobileNo(mobileNo));
        await dispatch(setUserId(userId));
        await dispatch(setUsername(username));
    }

    const checkLoginExpiration = (loginDateTime: Date) => {
        const todayDate = new Date().getDate()
        const todayMonth = new Date().getMonth()
        const todayYear = new Date().getFullYear()

        const loginDate = loginDateTime.getDate()
        const loginMonth = loginDateTime.getMonth()
        const loginYear = loginDateTime.getFullYear()

        if (todayDate !== loginDate || todayMonth !== loginMonth || todayYear !== loginYear) {
            logoutAction()
        }
    }

    const logoutAction = () => {
        clearAuthStorage()
        // clear the data from session storage
        sessionStorage.clear();
        navigate("/admin/login");
    }

    const milisecondsToDate = (secs) => {
        return new Date(secs);
    }

    return localStorage.getItem(StorageConstants.LOGIN_TOKEN) ? <Outlet/> : <Navigate to="/admin/login"/>
    // return <Outlet/>;
}

export default ProtectRoute;
